import * as yup from 'yup';
import { CurrencyModel } from '../../../../../../../../models/Settings/Financial/CurrencyModel';
import { CurrencyApplicationEnum } from '../../models';

export const schema = yup.object().shape({
  from: yup.string().nullable().required("Le champ 'from' est obligatoire."),
  to: yup.string().nullable().required("Le champ 'to' est obligatoire."),

  currency_application: yup.mixed<CurrencyApplicationEnum>().required(),

  currency: yup
    .mixed<CurrencyModel>()
    .nullable()
    .when('currency_application', {
      is: CurrencyApplicationEnum.FIXED,
      then: schema =>
        schema.required("Le champ 'currency' est obligatoire lorsque 'with_revenue' est activé."),
    }),

  fixed_at: yup
    .string()
    .nullable()
    .when('currency', {
      is: (value: CurrencyModel) => value && !value.is_local,
      then: schema =>
        schema.required(
          "Le champ 'fixed_at' est obligatoire lorsque 'currency_application' est FIXED."
        ),
    }),
});
